import React from 'react'
import { connect } from 'react-redux'
import Button from 'discada/dist/Button'

import { CopyToClipboard } from 'react-copy-to-clipboard'
import { getIsLoggedIn } from 'selectors/authSelectors'
import {
  getQuoteShortLink,
  getBlinderShortLink,
  getVehicleLink,
} from 'selectors/quoteSelectors'

import './SavedMessage.scss'

export class SavedMessage extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      copied: false,
      loaded: false,
    }
  }

  componentDidMount() {
    window.setTimeout(
      () => this._ismounted && this.setState({ loaded: true }),
      1,
    )
  }

  render() {
    let { quoteShortLink, isLoggedIn, blinder } = this.props,
      { copied } = this.state,
      label = isLoggedIn
        ? 'Copy Quote Link with Inventory Access'
        : 'Copy link to this share this Quote'

    if (blinder) label = 'Copy Quote Link without Inventory Access'

    return (
      <Button size="small" icon={copied ? 'check' : 'quote-left'} primary>
        <CopyToClipboard
          text={quoteShortLink}
          onCopy={() => this.setState({ copied: true })}
        >
          <span>{copied ? 'Link Copied!' : label}</span>
        </CopyToClipboard>
      </Button>
    )
  }
}

///////////////////////////////////////////////////////////////////////////////////////

export class VehicleLinkPreso extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      copied: false,
      loaded: false,
    }
  }

  componentDidMount() {
    window.setTimeout(
      () => this._ismounted && this.setState({ loaded: true }),
      1,
    )
  }

  render() {
    let { vehicleLink, isLoggedIn } = this.props,
      { copied } = this.state,
      label = isLoggedIn
        ? 'Copy link to Vehicle for Email Blast'
        : 'Copy link to share this Vehicle'

    return (
      <Button size="small" icon={copied ? 'check' : 'envelope'}>
        <CopyToClipboard
          text={vehicleLink}
          onCopy={() => this.setState({ copied: true })}
        >
          <span>{copied ? 'Link Copied!' : label}</span>
        </CopyToClipboard>
      </Button>
    )
  }
}

function mapStateToProps(state, op) {
  return {
    quoteShortLink: op.blinder
      ? getBlinderShortLink(state, op.vehicleId, op.quoteId)
      : getQuoteShortLink(state, op.vehicleId, op.quoteId),
    vehicleLink: getVehicleLink(state, op.vehicleId),
    isLoggedIn: getIsLoggedIn(state),
  }
}

export default connect(mapStateToProps)(SavedMessage)

export const VehicleLink = connect(mapStateToProps)(VehicleLinkPreso)
